<ng-container *ngIf="loadingState$ | async as loading">
  <span
    *ngIf="loading === spinnerState.VISIBLE"
    aria-hidden="false"
    tabindex="-1"
    id="chargementEnCours"
    class="dsd-sr-only"
    >{{ 'horsEcran.chargementEnCours' | translate }}</span
  >
  @if (chargementInitial) {
    <dsd-loading
      full-page="true"
      size="xs"
      *ngIf="loading === spinnerState.VISIBLE"
      class="dsd-jc-center"
    >
      {{ 'horsEcran.chargementEnCours' | translate }}
    </dsd-loading>
  } @else {
    <dsd-loading *ngIf="loading === spinnerState.VISIBLE" class="dsd-jc-center"> </dsd-loading>
  }
  <span
    *ngIf="loading === spinnerState.CACHE && !hideHorsEcran"
    id="chargementTermine"
    [hidden]="isHidden"
    class="dsd-sr-only"
    tabindex="-1"
    >{{ 'horsEcran.chargementTermine' | translate }}</span
  >
</ng-container>
